import React from 'react';
export type TokenContextProps = {
    token: string | null,
    setToken: (value: string | null) => void,
    expiration: Date | null,
    setExpiration: (value: Date | null) => void,
};

const TokenContext: React.Context<TokenContextProps> = React.createContext<TokenContextProps>({
    token: null,
    setToken: () => {},
    expiration: null,
    setExpiration: () => {},
});

export default TokenContext;